import { render, staticRenderFns } from "./unpublished_posts.vue?vue&type=template&id=1dccf793"
import script from "./unpublished_posts.vue?vue&type=script&lang=js"
export * from "./unpublished_posts.vue?vue&type=script&lang=js"
import style0 from "./unpublished_posts.vue?vue&type=style&index=0&id=1dccf793&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports